import type { CentreData } from './types';

export const thePondsData: CentreData = {
  slug: 'the-ponds',
  name: 'Schoolola The Ponds',
  suburb: 'The Ponds',
  region: 'Hills District',
  state: 'NSW',
  stateName: 'New South Wales',
  status: 'operational',
  yearLevels: 'Kindergarten - Year 8',
  canonicalPath: '/centres/the-ponds/',
  heroImage: 'https://schoolola.com.au/centres/the-ponds-og.jpg',
  address: {
    street: '180 Riverbank Dr',
    city: 'The Ponds',
    postcode: '2769',
    lat: -33.7088,
    lng: 150.9049,
  },
  contact: {
    phone: '+61 423 214 017',
    phoneHref: '+61423214017',
    email: 'rousehill@schoololatutoring.com.au',
  },
  hours: {
    monday: { opens: '17:30', closes: '20:00' },
    tuesday: { opens: '16:00', closes: '18:30' },
    wednesday: { opens: '17:30', closes: '20:00' },
    thursday: { opens: '17:30', closes: '20:00' },
    friday: { opens: '17:00', closes: '19:30' },
    saturday: null,
    sunday: null,
  },
  heroSubtitle:
    'OC, selective school and NAPLAN preparation by qualified NSW Curriculum teachers using the proven TMRW™ methodology.',
  trustStrip: [
    { k: 'In-person', v: '180 Riverbank Dr' },
    { k: 'Mon - Fri', v: 'Afternoons & evenings' },
    { k: 'Kindergarten - Year 8', v: 'All primary year levels' },
    { k: 'NSW Curriculum', v: 'Qualified teachers' },
  ],
  breadcrumb: { regionLabel: 'Hills District' },
  googleRating: {
    value: 5.0,
    count: 10,
    profileUrl: 'https://www.google.com/search?q=Schoolola+The+Ponds',
  },
  reviews: [
    {
      author: 'Jana Oo',
      rating: 5,
      timeAgo: '2 months ago',
      datePublished: '2026-03-25',
      body: "My daughter has attended Schoolola for a term, and I'm pleased to say that she enjoys it and goes for the lessons willingly! The centre director is very approachable and listens to feedback. The tutors are also responsible and hardworking.",
    },
    {
      author: 'Anubha Saxena',
      rating: 5,
      timeAgo: '3 months ago',
      datePublished: '2026-02-22',
      body: "I highly recommend this centre! The teaching approach is excellent, with a strong focus on building clear concepts and bridging learning gaps. The manager and staff are truly dedicated to supporting our children's educational journey.",
    },
    {
      author: 'Vivek Nair',
      rating: 5,
      timeAgo: '4 months ago',
      datePublished: '2026-01-28',
      body: "Schoolola has been an excellent support for my child's learning journey. I really appreciate the additional online tests provided during school holidays - they keep the kids engaged and help reinforce what they have learned.",
    },
    {
      author: 'Samatta Jade',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-28',
      body: "My daughter is in Year 3 and has been attending tutoring with this company for a few months now, and I've seen such a big improvement in her confidence and schoolwork. She used to struggle with reading and maths, but now she's much more confident.",
    },
    {
      author: 'Josetta Sara Joseph',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-30',
      body: "After moving to Australia, my son needed additional support to adjust to the new education system. We found Schoolola tutoring, and it has been a great help. Gopal and team were supportive and knowledgeable.",
    },
    {
      author: 'Sundeep Dornadula',
      rating: 5,
      timeAgo: '7 months ago',
      datePublished: '2025-10-28',
      body: 'My son really enjoyed the classes and coaching offered here. The course is really planned from basics to advanced. With 1:3 teacher ratio my son gets the complete attention he needed.',
    },
    {
      author: 'Pooja Singh',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-25',
      body: 'Highly recommend Schoolola tutoring service! The tutors are incredibly patient and pay great attention to detail, ensuring every child understands concepts thoroughly. With a small batch size, each student gets personalised attention.',
    },
    {
      author: 'Faraz Faheem',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-22',
      body: "We've had a great experience with Schoolola Tutoring. Since joining last term, we've seen a real boost in our daughters' confidence and understanding. The teachers use a clear and practical approach to learning.",
    },
    {
      author: 'Yulie Savitri',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-25',
      body: "We're really happy with Schoolola! My son's tutor is very attentive, caring, proactive, supportive and passionate. My son enjoys going to tutoring and always looks forward to his sessions.",
    },
    {
      author: 'Ankit Bhandari',
      rating: 5,
      timeAgo: '11 months ago',
      datePublished: '2025-06-22',
      body: 'Skilled and very helpful coaching staff. They help kids to focus on the areas which require additional effort. Continuous feedback is what makes a big difference.',
    },
  ],
  suburbsServed: ['Tallawong', 'The Ponds', 'Rouse Hill'],
  programs: [
    {
      id: 'oc',
      title: 'OC TMRW™ Preparation',
      yearPill: { label: 'Yr 3 - 4', tone: 'info' },
      tagline: 'Comprehensive OC exam preparation with proven TMRW™ strategies',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading'],
      educationalLevel: 'Year 3 to Year 4',
      description: 'Comprehensive OC exam preparation for primary students using the proven TMRW™ methodology, with practice tests and structured strategy training.',
      featured: 'popular',
    },
    {
      id: 'selective',
      title: 'Selective TMRW™ Preparation',
      yearPill: { label: 'Yr 5 - 6', tone: 'info' },
      tagline: 'Expert coaching for selective school entrance examinations',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading', 'Writing'],
      educationalLevel: 'Year 5 to Year 6',
      description: 'Expert coaching for selective school entrance examinations, specialised for primary students using the TMRW™ methodology.',
    },
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'K - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all primary year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to fractions', 'Writing structure across genres'],
      educationalLevel: 'Kindergarten to Year 8',
      description: 'Core English and mathematics tutoring for Kindergarten through Year 8 students, aligned to the NSW Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
  ],
  differentiators: [
    {
      title: 'NSW Curriculum specialists',
      body: "Lessons map to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Regular assessments tracked against ACARA bands.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Small group sizes for genuine individual attention while keeping the energy of peer learning.',
      icon: 'Users',
    },
    {
      title: 'OC and Selective track record',
      body: 'Students placed at Girraween High, Castle Hill High and other Hills District selective schools.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'What year levels do you tutor at The Ponds?',
      answer: 'Kindergarten through Year 8. Foundations covers all primary year levels in English and maths; OC, Selective and NAPLAN programmes target specific testing years.',
    },
    {
      question: 'Where is The Ponds centre located?',
      answer: 'Schoolola The Ponds operates from 180 Riverbank Dr, The Ponds NSW 2769.',
    },
    {
      question: 'What are your operating hours at The Ponds?',
      answer: 'Monday 5:30 PM - 8:00 PM, Tuesday 4:00 PM - 6:30 PM, Wednesday 5:30 PM - 8:00 PM, Thursday 5:30 PM - 8:00 PM, Friday 5:00 PM - 7:30 PM.',
    },
    {
      question: 'What does the free assessment include?',
      answer: 'A full diagnostic assessment, a 1:1 parent consultation, and a written learning plan with the recommended programme.',
    },
  ],
};
